/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = ManufacturerMenu
 *
 * 2 = EurorepairParts
 *
 * 3 = Flexible
 *
 * -1 = All
 */
export enum ServicePlanClassType {
  ManufacturerMenu = 1,
  EurorepairParts = 2,
  Flexible = 3,
  All = -1,
}
